/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ILxs2ColumnContentBlock contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum width {
    fullWidth = 'fullWidth',
    container = 'container'
}

export const enum moduleLayout {
    default = 'default',
    downloads = 'downloads',
    contact = 'contact'
}

export const enum imagePlacement {
    left = 'left',
    right = 'right'
}

export const enum actionableRegion {
    imageAndLinks = 'imageAndLinks',
    linksOnly = 'linksOnly'
}

export const enum textTheme {
    dark = 'dark',
    light = 'light'
}

export interface ILxs2ColumnContentBlockConfig extends Msdyn365.IModuleConfig {
    width?: width;
    moduleLayout?: moduleLayout;
    imagePlacement?: imagePlacement;
    preheading?: string;
    heading?: IHeadingData;
    paragraph?: Msdyn365.RichText;
    image?: Msdyn365.IImageData;
    links?: ILinksData[];
    ctaButton?: ICtaButtonData;
    additionalContent?: IAdditionalContentData[];
    backgroundColor?: string;
    anchorId?: string;
    actionableRegion?: actionableRegion;
    imageLink?: Msdyn365.ILinkData;
    imageAriaLabel?: string;
    textTheme?: textTheme;
    className?: string;
    clientRender?: boolean;
    showProductRequestButton?: boolean;
}

export interface ILxs2ColumnContentBlockResources {
    productRequestModalLeftEyebrow: string;
    productRequestModalLeftHeading: string;
    productRequestModalLeftText: string;
    productRequestModalLeftWhySaltigoHeading: string;
    productRequestModalLeftBullet1: string;
    productRequestModalLeftBullet2: string;
    productRequestModalLeftBullet3: string;
    productRequestModalLeftBullet4: string;
    productRequestModalLeftBullet5: string;
    productRequestModalCapabilitiesHeading: string;
    productRequestModalCapabilityCropProtectionTitle: string;
    productRequestModalCapabilityCropProtectionText: string;
    productRequestModalCapabilityCropProtectionLinkText: string;
    productRequestModalCapabilityCropProtectionLinkUrl: string;
    productRequestModalCapabilityPharmaTitle: string;
    productRequestModalCapabilityPharmaText: string;
    productRequestModalCapabilityPharmaLinkText: string;
    productRequestModalCapabilityPharmaLinkUrl: string;
    productRequestModalCapabilitySpecialtyChemicalsTitle: string;
    productRequestModalCapabilitySpecialtyChemicalsText: string;
    productRequestModalCapabilitySpecialtyChemicalsLinkText: string;
    productRequestModalCapabilitySpecialtyChemicalsLinkUrl: string;
    productRequestModalCapabilityTechnologiesTitle: string;
    productRequestModalCapabilityTechnologiesText: string;
    productRequestModalCapabilityTechnologiesLinkText: string;
    productRequestModalCapabilityTechnologiesLinkUrl: string;
    productRequestModalCapabilityServicesTitle: string;
    productRequestModalCapabilityServicesText: string;
    productRequestModalCapabilityServicesLinkText: string;
    productRequestModalCapabilityServicesLinkUrl: string;
    productRequestModalFormHeading: string;
    productRequestModalFormSubheading: string;
    productRequestModalFieldMolecule: string;
    productRequestModalFieldMoleculeHelper: string;
    productRequestModalFieldMoleculePlaceholder: string;
    productRequestModalFieldQuantity: string;
    productRequestModalFieldQuantityHelper: string;
    productRequestModalFieldQuantityPlaceholder: string;
    productRequestModalFieldDeliveryDate: string;
    productRequestModalFieldDeliveryDateHelper: string;
    productRequestModalFieldDeliveryDatePlaceholder: string;
    productRequestModalFieldTargetPrice: string;
    productRequestModalFieldTargetPriceHelper: string;
    productRequestModalFieldTargetPricePlaceholder: string;
    productRequestModalFieldAdditionalInfo: string;
    productRequestModalFieldAdditionalInfoHelper: string;
    productRequestModalFieldAdditionalInfoPlaceholder: string;
    productRequestModalContactDetailsHeading: string;
    productRequestModalFieldFirstName: string;
    productRequestModalFieldFirstNamePlaceholder: string;
    productRequestModalFieldLastName: string;
    productRequestModalFieldLastNamePlaceholder: string;
    productRequestModalFieldCompany: string;
    productRequestModalFieldCompanyPlaceholder: string;
    productRequestModalFieldEmail: string;
    productRequestModalFieldEmailPlaceholder: string;
    productRequestModalFieldPhone: string;
    productRequestModalFieldPhonePlaceholder: string;
    productRequestModalSubmitButton: string;
    productRequestModalCancelButton: string;
    productRequestModalSuccessHeading: string;
    productRequestModalSuccessText: string;
    productRequestModalSubmitError: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export const enum LinksIcon {
    none = 'none',
    download = 'download',
    mail = 'mail',
    arrowRight = 'arrowRight',
    external = 'external'
}

export interface ILinksData {
    link?: ILinkData;
    icon?: LinksIcon;
}

export interface ICtaButtonData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IAdditionalContentData {
    heading?: string;
    subtext?: string;
    links?: ILinksData[];
}

export interface ILinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface ILxs2ColumnContentBlockProps<T> extends Msdyn365.IModule<T> {
    resources: ILxs2ColumnContentBlockResources;
    config: ILxs2ColumnContentBlockConfig;
}
